// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__3-CYI","detailsBorder":"styles_detailsBorder__3YSxa"};